module.exports = __webpack_public_path__ + "img/liveBroadcast_show1.6eb7ac8c.png";